import React from 'react';
import RoleApp from './components/RoleApp';

const RoleAppPage: React.FC = () => {
    return <RoleApp />;
};

export default RoleAppPage;
